// TODO: eslint
/* eslint-disable react/no-is-mounted */
import urlResolver from 'edrolo/utils/URLResolver';

const ExamSolutionDataFetcher = {
  getInitialState() {
    return {
      solutionData: { questions: [] },
      solutionError: false,
      solutionLoaded: false,
      solutionLoadedForExam: null,
      fetchingSolution: false,
    };
  },

  fetchSolutionData(examId) {
    if (this.state.fetchingSolution || this.state.solutionError) {
      return;
    }
    this.setState({ fetchingSolution: true });

    const url = urlResolver.reverse('api:get:exam-detail-solution', {
      examId,
    });

    $.ajax({
      url,
      dataType: 'json',
      success: function (newSolutionData) {
        if (this.isMounted()) {
          this.setState({
            solutionData: newSolutionData,
            solutionLoaded: true,
            solutionLoadedForExam: examId,
            fetchingSolution: false,
          });
        }
      }.bind(this),
      error: function (xhr, status, err) {
        if (this.isMounted()) {
          this.setState({
            fetchingSolution: false,
            solutionError: true,
          });
        }
      }.bind(this),
    });
  },
};

export default ExamSolutionDataFetcher;
